module.exports = __webpack_public_path__ + "static/clients-mobile-b232fde1068440e96a1c95402ac023a8.svg";